import { contentFactoryMap } from "../../../utils/constants";

export default {
  [contentFactoryMap.article]: {
    title: "",
    content: "",
  },
  [contentFactoryMap.contentCreator]: {
    prompt: "",
    noImages: false,
  },
  [contentFactoryMap.videoContentCreator]: {
    files: [],
    paragraphs: null,
    paragraphsTouched: false,
  },
  [contentFactoryMap.reframer]: {
    name: "",
    file: null,
    url: null,
    start: "",
    end: "",
    noScenes: false,
    detectionRes: "",
  },
};
